import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import FCSlider from '../../fc_slider/fc_slider';
import Poster from '../../poster/poster';
import { imageSizesLookup } from '../../../../utils/cloudinary_asset_util';

export default function HeaderMedia(props) {
  if (!props) {
    return null;
  }

  const {
    slideShowData,
    posterImg,
    videoData,
    videoAdData,
    iframeData,
    title
  } = props;

  if (slideShowData.length) {
    return <FCSlider slideShowData={slideShowData} title={title} />;
  }

  if (!isEmpty(videoData)) {
    const feed = get(videoData, 'feedId') || '';
    const site = get(videoAdData, 'site') || '';
    const zone = encodeURIComponent(get(videoAdData, 'adzone') || '');
    const tags = encodeURIComponent(
      (get(videoAdData, 'tags') || []).join(',') || ''
    );

    // TBD: Change src to normal fastcompany.com URL
    // after this repo has been deployed and redesign-slot-fc
    // branch new-embed-adtag has been merged in and deployed
    return (
      <div className="poster-video-wrapper">
        <iframe
          className="poster-video-wrapper__video"
          src={`//www.fastcompany.com/embed/${feed}?site=${site}&zone=${zone}&tags=${tags}`}
        />
      </div>
    );
  }

  if (!isEmpty(iframeData)) {
    const source = get(iframeData, 'url');
    return (
      <div className="poster-video-wrapper">
        <iframe className="poster-video-wrapper__video" src={source} />
      </div>
    );
  }

  const posterSrc = get(posterImg, 'source');
  const posterCaption = get(posterImg, 'caption');
  const metadata = {
    title,
    featured_image: { source: posterSrc },
    assetSizes: get(imageSizesLookup, 'poster'),
    noLazy: true
  };

  if (!posterSrc) {
    return null;
  }

  return (
    <div>
      <Poster metadata={metadata} className="post-featured" />

      {posterCaption
        ? <div
            className="post__featured-caption"
            dangerouslySetInnerHTML={{ __html: posterCaption }}
          />
        : <div className="post__featured-caption--no-caption" />}
    </div>
  );
}

HeaderMedia.defaultProps = {
  slideShowData: [],
  posterImg: '',
  videoData: {},
  videoAdData: {},
  iframeData: {}
};

HeaderMedia.propTypes = {
  title: PropTypes.string.isRequired,
  slideShowData: PropTypes.arrayOf(
    PropTypes.shape({
      imgUrl: PropTypes.string,
      caption: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
    })
  ),
  posterImg: PropTypes.shape({}),
  videoData: PropTypes.shape({}),
  videoAdData: PropTypes.shape({}),
  iframeData: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./src/views/components/post/header/post_header.js